import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { valueFormatter } from './ScenarioGraph/helperFunctions';
import { formatLargeNumber } from '../../../utility/formatNumbers';

//component to display the bar graph for the summary projection for an anaylsis page
export default function BarGraph({ data = [], unit = '$' }) {
  const multipleKeys = data[0] && Object.keys(data[0]).length > 2;
  const keys = Object.keys(data[0])?.filter((key) => key !== 'date');

  const gradientOffset = () => {
    const dataMax = Math.max(...data.map((i) => i[keys[0]]));
    const dataMin = Math.min(...data.map((i) => i[keys[0]]));

    if (dataMax <= 0) {
      return 0;
    }
    if (dataMin >= 0) {
      return 1;
    }

    return dataMax / (dataMax - dataMin);
  };

  const off = gradientOffset();

  const renderToolTip = function (entry) {
    const { payload } = entry;
    if (payload && payload.length) {
      if (!multipleKeys) {
        const { date, Value } = payload[0].payload;
        return (
          <div className="bg-white p-3 shadow-md rounded-md focus:outline-none">
            <div className="text-base text-neutral-500">{date}</div>
            <div className="text-base text-neutral-700">
              {unit === '$'
                ? `${unit}${formatLargeNumber(Value)}`
                : `${Value}${unit}`}
            </div>
          </div>
        );
      } else {
        const { date } = payload[0].payload;
        return (
          <div className="bg-white p-3 shadow-md rounded-md focus:outline-none">
            <div className="text-base text-neutral-500">{date}</div>
            {payload.map((p) => (
              <div key={p.name} className="text-base text-neutral-700">
                {`${p.name}: ${
                  unit === '$'
                    ? `${unit}${formatLargeNumber(p.value)}`
                    : `${p.value}${unit}`
                }`}
              </div>
            ))}
          </div>
        );
      }
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={600}
        height={400}
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: -20,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="2 2" />
        <XAxis dataKey="date" color="#262626" tickMargin={8} />
        <YAxis
          width={85}
          tickFormatter={(tick) => valueFormatter(tick, unit)}
          type="number"
          style={{ fontSize: '12px' }}
        />
        <Tooltip content={renderToolTip} />
        {/* if there are multiple keys, then we are stacking the bars */}
        {!multipleKeys && (
          <Bar
            type="monotone"
            dataKey={keys[0]}
            stroke="#71D09D"
            fill="#b3e6cb"
            radius={[4, 4, 0, 0]}
            fillOpacity={0.5}
          />
        )}
        {multipleKeys &&
          Object.keys(data[0])
            .filter((key) => key !== 'date')
            .map((key, index) => (
              <Bar
                key={key}
                dataKey={key}
                stackId="a"
                radius={index === 0 ? null : [4, 4, 0, 0]}
                fillOpacity={0.8}
                stroke="#71D09D"
                fill={index === 0 ? '#218C52' : '#b3e6cb'}
              />
            ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
